import { type ForwardRefExoticComponent, forwardRef } from 'react';

import { Divider } from '../divider';
import { PaginationItem } from './pagination-item';
import { PaginationList } from './pagination-list';
import { PaginationNextButton } from './pagination-next-button';
import { PaginationPageButton } from './pagination-page-button';
import { PaginationPageItems } from './pagination-page-items';
import { PaginationPreviousButton } from './pagination-previous-button';
import { PaginationReadout } from './pagination-readout';
import { PaginationRoot } from './pagination-root';
import type { PaginationPropsInterface } from './types/pagination.types';

/**
 * @since 7.42.0
 */
export const Pagination = forwardRef<HTMLDivElement, PaginationPropsInterface>(
  (props: PaginationPropsInterface, forwardedRef) => {
    const { divider = false, ...rest } = props;
    return (
      <Pagination.Root ref={forwardedRef} {...rest}>
        {divider ? <Divider /> : null}
        <Pagination.List>
          <Pagination.Item>
            <Pagination.PreviousButton />
          </Pagination.Item>
          <Pagination.PageItems />
          <Pagination.Readout />
          <Pagination.Item>
            <Pagination.NextButton />
          </Pagination.Item>
        </Pagination.List>
      </Pagination.Root>
    );
  },
) as ForwardRefExoticComponent<PaginationPropsInterface> & {
  Root: typeof PaginationRoot;
  List: typeof PaginationList;
  Item: typeof PaginationItem;
  PageItems: typeof PaginationPageItems;
  NextButton: typeof PaginationNextButton;
  PreviousButton: typeof PaginationPreviousButton;
  PageButton: typeof PaginationPageButton;
  Readout: typeof PaginationReadout;
};

Pagination.Root = PaginationRoot;
Pagination.Item = PaginationItem;
Pagination.List = PaginationList;
Pagination.PageItems = PaginationPageItems;
Pagination.NextButton = PaginationNextButton;
Pagination.PreviousButton = PaginationPreviousButton;
Pagination.PageButton = PaginationPageButton;
Pagination.Readout = PaginationReadout;

Pagination.displayName = 'Pagination';
